<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div v-if="service._id" class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ service.title }}</h3>
            <p class="text-center">{{ service.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات دسته پرداخت</h4>
          </div>
          <div class="widget-body">
            <form id="serviceForm" class="form-horizontal">
              <!-- service name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام دسته</label>
                <div class="col-lg-6">
                  <input type="text" name="serviceName" class="form-control" v-model="service.title" />
                </div>
              </div>
              <!-- service type -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نوع دسته</label>
                <div class="col-lg-6">
                  <select v-model="service.paymentTypeOfsegment" class="form-control" name="serviceCat">
                    <option value="" selected disabled>انتخاب کنید</option>
                    <option value="deactive"> پرداخت غیرفعال</option>
                    <option value="storeMode">استفاده از sdk مربوطه</option>
                    <option value="direct">لینک پرداخت</option>
                  </select>
                </div>
              </div>

              <!-- is rules -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">قوانین سگمنت</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id="" v-model="service.segmentRules" multiple>
                    <option value="" selected disabled>انتخاب کنید</option>
                    <option v-for="rule in rules" :key="rule._id" :value="rule._id">{{ rule.title }}</option>
                  </select>
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت سگمنت</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id="" v-model="service.isSegmentActive">
                    <option :value="true">فعال</option>
                    <option :value="false">غیر فعال</option>
                  </select>
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/pservices">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentServicesService from '../../../../services/paymentSegmentService';
import PermissionService from '../../../../services/UsersRulePermissions';

export default {
  name: 'paymentSegment',
  data() {
    return {
      service: { segmentRules: [] },
      rules: [],
    };
  },
  created() {
    this.getRules();
    if (this.$route.query.id) this.getService(this.$route.query.id);
  },
  methods: {
    async getRules() {
      try {
        const resData = await PermissionService.getRules({});
        this.rules = resData;
      } catch (err) {
        console.log(err);
      }
    },
    async getService(id) {
      try {
        const service = await paymentServicesService.getSegment(id);
        this.service = service;
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      const body = this.service;
      let id;
      try {
        if (this.$route.query.id) {
          await paymentServicesService.editSegment(body);
          id = this.$route.query.id;
        } else {
          const sarvice = await paymentServicesService.addSegment(body);
          id = sarvice._id;
          this.$route.query.id = id;
        }

        this.getService(id);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
